module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hres80x-history-heal-family"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#historyHealFamily"
    }
  }, [_c('h3', {
    staticClass: "box-title color-skin"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES80XP3']['10']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "historyHealFamily"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('div', {
    staticClass: "hisheal-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP3']['20']) + " " + _vm._s(_vm.labels['HRES80XP3']['25']))]), _vm._v(" "), _c('div', {
    staticClass: "table-overflow"
  }, [_c('table', {
    staticClass: "table-1"
  }, [_c('tr', [_c('td', {
    staticClass: "bg-color-skin text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP3']['30']))]), _vm._v(" "), _c('td', {
    staticClass: "bg-color-skin text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP3']['40']))]), _vm._v(" "), _c('td', {
    staticClass: "bg-color-skin",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP3']['50']))])]), _vm._v(" "), _vm._l((_vm.dataHisHealFamily), function(dataRow, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dataRow.numseq))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dataRow.desrelat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dataRow.dessick))])])
  })], 2)]), _vm._v(" "), (_vm.dataHisHealFamily.length === 0) ? _c('div', {
    staticClass: "text-center hisheal-nodata"
  }, [_vm._v("\n            No data found.\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6382d572!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres80x/historyHealFamily.vue
// module id = 3819
// module chunks = 1